import { message } from "antd";
import internalApi from "../axios/internalApi";

export const getCustomersList = async (
  pageNumber = 1,
  itemPerPage = 10,
  text
) => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: `admin/list-customers?pageNumber=${pageNumber}&itemPerPage=${itemPerPage}${
        text ? `&text=${text}` : ""
      }`,
    });
  } catch (error) {
    // message.error(error?.data?.message);
  }
};

export const getCustomersDetils = async (id) => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: `admin/find-customer-by-id/${id}`,
    });
  } catch (error) {
    // message.error(error?.data?.message);
  }
};

export const resetCustomerPassword = async (payload) => {
  try {
    return await internalApi.patch(
      {
        server: "api/v1/",
        path: `admin/update-password`,
      },
      payload
    );
  } catch (error) {
    // message.error(error?.data?.message);
  }
};

export const deleteCustomer = async (id) => {
  try {
    return await internalApi.delete({
      server: "api/v1/",
      path: `admin/delete-customer/${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const updateCustomer = async (id, payload) => {
  try {
    return await internalApi.patch(
      {
        server: "api/v1/",
        path: `admin/update-customer?userId=${id}`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const exportCustomersToCsv = async (customerIds) => {
  try {
    return await internalApi.post(
      {
        server: "api/v1/",
        path: "admin/export-customers-csv",
      },
      customerIds,
      {
        responseType: 'blob',
      }
    );
  } catch (error) {
    message.error(error?.data?.message || "Failed to export customers");
    throw error;
  }
};
